import { render, staticRenderFns } from "./404.vue?vue&type=template&id=56cbe42e&scoped=true&"
import script from "./404.vue?vue&type=script&lang=js&"
export * from "./404.vue?vue&type=script&lang=js&"
import style0 from "./404.vue?vue&type=style&index=0&id=56cbe42e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56cbe42e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3812539345/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56cbe42e')) {
      api.createRecord('56cbe42e', component.options)
    } else {
      api.reload('56cbe42e', component.options)
    }
    module.hot.accept("./404.vue?vue&type=template&id=56cbe42e&scoped=true&", function () {
      api.rerender('56cbe42e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/errors/404.vue"
export default component.exports